export default __webpack_public_path__ + "static/media/diamond-img.99db24c7.webp";